import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { travelClinicRoutes } from 'modules/forms/constants/routes.constants';
import FormStep from '../FormStep';
import FormSubmit from '../FormSubmit';

const FormRoutes = (): JSX.Element => {
  return (
    <Switch>
      {travelClinicRoutes?.map((route, index) => (
        <Route
          exact
          path={route}
          component={() =>
            index === travelClinicRoutes.length - 1 ? (
              <FormSubmit key={route} />
            ) : (
              <FormStep key={route} />
            )
          }
        />
      ))}
      <Redirect to={travelClinicRoutes[0]} />
    </Switch>
  );
};

export default FormRoutes;
